import { useMemoizedFn, useMount } from 'ahooks';
import { Radio, TableColumnsType } from 'antd';
import { RevxTable } from 'components';
import { Paged } from 'domains/appDomain';
import { NetworkMember, NetworkPESwitchEnum } from 'domains/networkDomain';
import { Organization } from 'domains/orgDomain';
import { useOrg } from 'hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import networkService from 'services/networkService';

export const NetworkJoinedTable = ({ orgs }: { orgs: Organization[] }) => {
  const { t } = useTranslation();
  const [pagedData, setPagedData] = useState<Paged<NetworkMember>>();
  const [page, setPage] = useState<number>(1);
  const [size, setSize] = useState<number>(20);
  const [loading, setLoading] = useState<boolean>(false);
  // const orgs = useAppSelector((state) => state.org.list);
  const contextOrg = useOrg();

  const getList = useMemoizedFn(async (size: number = 20, page: number = 1) => {
    setLoading(true);
    try {
      const res = await networkService.getJoinedMembers(
        contextOrg?.id || 1,
        size,
        page
      );
      setPagedData(res);
      setPage(res.number + 1);
    } finally {
      setLoading(false);
    }
  });
  useMount(async () => {
    getList();
  });

  const peswitchChange = useMemoizedFn(async (payload: NetworkMember) => {
    setLoading(true);
    try {
      await networkService.updateMember(payload);
      await getList(size, page);
    } finally {
      setLoading(false);
    }
  });

  const columns: TableColumnsType<NetworkMember> = [
    {
      title: t('platform.network.networkName'),
      dataIndex: 'networkId',
      render: (value) => {
        return orgs?.find((item) => item.id === value)?.name;
      },
    },
    {
      title: t('platform.network.pricingData'),
      dataIndex: 'peswitch',
      align: 'center',
      width: 260,
      render: (value, record) => {
        return (
          <Radio.Group
            value={value}
            onChange={(e) =>
              peswitchChange({
                ...record,
                peswitch: e.target.value as NetworkPESwitchEnum,
              })
            }
          >
            <Radio value={NetworkPESwitchEnum.PRIVATE}>
              {t('common.private')}
            </Radio>
            <Radio value={NetworkPESwitchEnum.LIVE}>{t('common.live')}</Radio>
          </Radio.Group>
        );
      },
    },
  ];

  const onTableChange = useMemoizedFn((pagination, filters, sorter, extra) => {
    switch (extra.action) {
      case 'paginate':
        setPage(pagination.current);
        setSize(pagination.pageSize);
        getList(pagination.pageSize, pagination.current);
        break;
    }
  });
  return (
    <div style={{ width: '50%' }}>
      <RevxTable<NetworkMember>
        loading={loading}
        columns={columns}
        size="small"
        pagination={{
          pageSize: size,
          current: page,
          total: pagedData?.totalElements,
        }}
        indentSize={20}
        dataSource={pagedData?.content || []}
        onChange={onTableChange}
      />
    </div>
  );
};
